import { render } from "./TheOsCard.vue?vue&type=template&id=662b755e"
import script from "./TheOsCard.vue?vue&type=script&lang=js"
export * from "./TheOsCard.vue?vue&type=script&lang=js"

import "./TheOsCard.vue?vue&type=style&index=0&id=662b755e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__